export const recaptchaSiteKey = '6LcLj_UUAAAAAEPkQiazEs_toldZRG6hf0QA9Imh';
